import { combineReducers } from 'redux';
import modalReducer from './modalReducer';
import tablaReducer from './tablaReducer';
import operationsReducer from './operationsReducer';

export interface IApplicationState {

}

const rootReducer = combineReducers({
    operationsReducer,
    modalReducer,
    tablaReducer
});


export default rootReducer;